import { DndContext, DragEndEvent } from "@dnd-kit/core"
import { Grid } from "@mui/material"
import { useEffect } from "react"
import { GameDraggableId, GameDroppableId } from "../../Games"
import { useGamesAPI, useGamesData } from "../../context/GamesProvider"
import { useFillGameReducer } from "./FillGameReducer"

export const FillGameModule = () => {
  console.log("FillGameModule render")

  //  CONTEXTS
  const { current } = useGamesData()
  const { validateGame, setProgress } = useGamesAPI()
  const { draggables, links, dispatch, data } = useFillGameReducer({
    current,
  })

  //  STATES
  useEffect(() => {
    if (data.isValid) validateGame()
  }, [data.isValid, validateGame])

  useEffect(() => {
    setProgress(data.progress ?? 0)
  }, [data.progress, setProgress])

  //  HANDLES
  const handleDragEnd = (event: DragEndEvent) => {
    console.log(`drop ${event.active.id} over ${event.over?.id ?? "nothing"}`)
    if (
      event.over &&
      event.active.data.current &&
      event.active.data.current?.hostedBy !== event.over.id &&
      event.active.data.current?.hostedBy !== ""
    )
      dispatch({
        type: "switch",
        drag: event.active.id as GameDraggableId,
        from: event.active.data.current.hostedBy,
        to: event.over.id as GameDroppableId,
        other: "",
      })
    else if (event.over)
      dispatch({
        type: "dropTo",
        drag: event.active.id as GameDraggableId,
        to: event.over.id as GameDroppableId,
      })
    else dispatch({ type: "reset", id: event.active.id as GameDraggableId })

    dispatch({ type: "validate" })
  }

  return (
    <DndContext onDragEnd={handleDragEnd}>
      <Grid item container
        justifyContent="center"
        // mt={"1em"}
        mb={5}
      >
        <Grid
          item
          container
          // spacing={4}
          xs={10}
          justifyContent="center"
          paddingTop="2em"
          paddingBottom="2em"
          bgcolor={"grey.50"}
          borderRadius={5}
          minHeight={"8em"}
        >
          {draggables}
        </Grid>
        <Grid
          container
          item
          spacing={4}
          xs={10}
          justifyContent="center"
          alignItems="center"
          mb="5em"
        >
          {links}
        </Grid>
      </Grid>
    </DndContext>
  )
}
